import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import ExpandIcon from '../../../../../../images/v2/components/dropdown/expand_icon';
import * as tracking from '../../../../../../tracking';
import ForecastTooltip from '../../../../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import {ForecastTooltipFormulaRenderer} from '../../../../../ForecastTooltipFormulaRenderer';

const tableRow = ({tableName, row, showMilestones, showRoles, isTableExpanded, color, highlightColumnIndex, projectTotals, columnWidth, lockedColumnIndexMap, disabledColumnIndexes, canExpand, columnTooltipText, rowTooltipText}) => {
	const [isExpanded, setIsExpanded] = useState(canExpand);
	const rowName = row[0][0].toLowerCase();
	const offsetIndex = row[0].findIndex(nestedRow => nestedRow.name === 'Offset');

	const handleRowExpansionToggle = () => {
		setIsExpanded(!isExpanded);

		if (row && row[0] && row[0][0]) {
			const expandCollapseLabel = !isExpanded ? 'Expanded' : 'Collapsed';
			const clicked = `${row[0][0]} ${expandCollapseLabel}`;
			tracking.trackElementClicked(clicked, {
				'Table name': tableName,
			});
		}
	};

	useEffect(() => {
		setIsExpanded(isTableExpanded);
	}, [isTableExpanded]);

	return (
		<tr>
			{row.map((rowValues, k) => {
				const tooltips = rowTooltipText || (columnTooltipText ? columnTooltipText[k] : null);
				const constantTooltip = tooltips ? tooltips['constantTooltip'] : null;
				const offsetTooltip = tooltips ? tooltips['offset'] : null;
				return rowValues !== null ? (
					<td
						key={k}
						style={{backgroundColor: `${k === 0 ? color : ''}`, width: projectTotals ? (k > 0 ? columnWidth : 1) + '%' : null}}
						className={`${lockedColumnIndexMap.get(k) && lockedColumnIndexMap.get(k).fullLock && !projectTotals ? ' locked ' : ''}${projectTotals ? ' totals-table ' : ''}${highlightColumnIndex === k ? ' highlighted ' : ''}${
							isExpanded && !projectTotals ? ' expanded-row ' : ''
						}${disabledColumnIndexes && disabledColumnIndexes.indexOf(k) > -1 ? ' disabled' : ''}`}
					>
						{rowValues.map((x, l) => {
							const tooltipItems = offsetIndex === l && offsetTooltip ? offsetTooltip : constantTooltip || (tooltips && tooltips[rowName] ? tooltips[rowName] : []);
							return !Array.isArray(x) && l === 0 ? (
								<div key={l} className={`row ${k === 0 ? 'row-name ' : ''} ${!projectTotals ? 'breakdown-table-row-name ' : ''} ${rowValues.length >= 2 ? 'thick-text ' : ''}`}>
									<ForecastTooltip maxWidth="600px" placement={'auto'} content={<ForecastTooltipFormulaRenderer items={tooltipItems} translatedMessage={true} />} disabled={!tooltips || (!tooltips[rowName] && !constantTooltip)}>
										{/* show expand icon only in the first element on the line and only if we use breakdown aka have arrays in the rowValues */}
										{k === 0 && rowValues.some(item => Array.isArray(item)) ? (
											<div key={l} className="name-expansion-wrapper" onClick={() => (canExpand ? handleRowExpansionToggle() : null)}>
												<span className="name">{x}</span>
												{canExpand ? <ExpandIcon expanded={isExpanded} useDarkIcon={true} /> : null}
											</div>
										) : (
											<div key={l} data-cy={`${projectTotals ? 'project-total' : 'table-total'}`}>
												{x}
											</div>
										)}
									</ForecastTooltip>
								</div>
							) : isExpanded && (Array.isArray(x) ? showMilestones || showRoles : x.shouldShow || (typeof x === 'string' && ((row[0][l].shouldShow !== undefined && row[0][l].shouldShow) || row[0][l].shouldShow === undefined))) ? (
								<div key={l} className={`row ${k === 0 ? 'row-name ' : ''}  ${rowValues.length > 2 ? 'thick-text ' : ''}`}>
									{Array.isArray(x) ? (
										x.map((y, m) =>
											Array.isArray(y) ? (
												y.map((role, n) =>
													showRoles ? (
														<ForecastTooltip
															maxWidth="600px"
															placement={'auto'}
															content={<ForecastTooltipFormulaRenderer items={tooltipItems} translatedMessage={true} />}
															disabled={!tooltips || (!tooltips[rowName] && !constantTooltip)}
														>
															<div key={n} className="role">
																{role}
															</div>
														</ForecastTooltip>
													) : null
												)
											) : showMilestones ? (
												<ForecastTooltip
													maxWidth="600px"
													placement={'auto'}
													content={<ForecastTooltipFormulaRenderer items={tooltipItems} translatedMessage={true} />}
													disabled={!tooltips || (!tooltips[rowName] && !constantTooltip)}
												>
													<div key={m} className="subtitle">
														{y}
													</div>
												</ForecastTooltip>
											) : null
										)
									) : (row[0][l].shouldShow !== undefined && row[0][l].shouldShow) || row[0][l].shouldShow === undefined ? (
										<ForecastTooltip maxWidth="600px" placement={'auto'} content={<ForecastTooltipFormulaRenderer items={tooltipItems} translatedMessage={true} />} disabled={!tooltips || (!tooltips[rowName] && !constantTooltip)}>
											<div key={l} className="subtitle">
												{/* When I wrote this, only God and I understood what I was doing  Now, God only knows. Something to do with the eye selector */}
												{x.name ? (x.shouldShow ? x.name : null) : row[0][l].shouldShow !== undefined ? (row[0][l].shouldShow ? x : 'jj') : x}
											</div>
										</ForecastTooltip>
									) : null}
								</div>
							) : null;
						})}
					</td>
				) : (
					false
				);
			})}
		</tr>
	);
};

tableRow.propTypes = {
	row: PropTypes.array,
	color: PropTypes.string,
	highlightColumnIndex: PropTypes.number,
	projectTotals: PropTypes.bool,
	columnWidth: PropTypes.number,
	canExpand: PropTypes.bool,

	// Used for Project totals (one row has different types in each column)
	columnTooltipText: PropTypes.array,

	// Used for other tables
	rowTooltipText: PropTypes.array,
};

export default tableRow;
